/** Mirror of the backend `skills` column sizes (`SKILL_*_MAX_LENGTH` in `skill_service.py`). */
export const SKILL_NAME_MAX_LENGTH = 200;
export const SKILL_SHORT_DESCRIPTION_MAX_LENGTH = 300;
